module.exports = __webpack_public_path__ + "img/Self-Empathy.0d372e0b.jpg";